import { RefObject, useEffect } from 'react';

const RTE_TOOLBAR_DROPDOWN_PORTAL = '[data-rte-toolbar-dropdown-portal]';

export const useCloseModal = (
  ref: RefObject<HTMLElement | null>,
  callback: (event?: MouseEvent | KeyboardEvent) => void,
  closeOnOutsideClick = true,
) => {
  useEffect(() => {
    const handleClick = (e: MouseEvent | KeyboardEvent) => {
      const target = e.target as Node;
      const el = target instanceof Element ? target : target.parentElement;
      if (el?.closest(RTE_TOOLBAR_DROPDOWN_PORTAL)) {
        return;
      }
      if (
        closeOnOutsideClick &&
        ref.current &&
        (!ref.current.contains(target as Node) ||
          (e as KeyboardEvent).key === 'Escape')
      ) {
        callback(e);
      }
    };

    document.addEventListener('mousedown', handleClick, true);
    document.addEventListener('keyup', handleClick, true);
    return () => {
      document.removeEventListener('mousedown', handleClick, true);
      document.removeEventListener('keyup', handleClick, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeOnOutsideClick]);
};
